import styled from "styled-components";

export const StyledUnmatchedEmail = styled.div`
    display: flex;
`;

export const StyledUnmatchedEmailImageContainer = styled.div`
    height: 64px;
    width: 64px;
    margin-right: 24px;
`;
